import { render, staticRenderFns } from "./ServiciosComponent.vue?vue&type=template&id=51039a9e"
import script from "./ServiciosComponent.vue?vue&type=script&lang=js"
export * from "./ServiciosComponent.vue?vue&type=script&lang=js"
import style0 from "./ServiciosComponent.vue?vue&type=style&index=0&id=51039a9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports